let portsData = [
    {
        key: 'A',
        ports: [
            {
                portName: 'A1',
                isActive: false,
                isDigital: false,
                isColor: '#E25432',
            },
            {
                portName: 'A2',
                isActive: false,
                isDigital: false,
                isColor: '#B0D745',
            },
        ],
    },

    {
        key: 'B',
        ports: [
            {
                portName: 'B1',
                isActive: false,
                isDigital: false,
                isColor: '#23DE93',
            },
            {
                portName: 'B2',
                isActive: false,
                isDigital: false,
                isColor: '#3A3A3A',
            },
        ],
    },

    {
        key: 'C',
        ports: [
            {
                portName: 'C1',
                isActive: false,
                isDigital: false,
                isColor: '#0ACEF7',
            },
            {
                portName: 'C2',
                isActive: false,
                isDigital: false,
                isColor: '#5061A8',
            },
        ],
    },

    {
        key: 'D',
        ports: [
            {
                portName: 'D1',
                isActive: false,
                isDigital: false,
                isColor: '#0E3C11',
            },
            {
                portName: 'D2',
                isActive: false,
                isDigital: false,
                isColor: '#DD1624',
            },
        ],
    },

    {
        key: 'E',
        ports: [
            {
                portName: 'E1',
                isActive: false,
                isDigital: false,
                isColor: '#F79B47',
            },
            {
                portName: 'E2',
                isActive: false,
                isDigital: false,
                isColor: '#F666D0',
            },
        ],
    },

    {
        key: 'F',
        ports: [
            {
                portName: 'F1',
                isActive: false,
                isDigital: false,
                isColor: '#3D5B53',
            },
            {
                portName: 'F2',
                isActive: false,
                isDigital: false,
                isColor: 'black',
            },
        ],
    },
]

let defaultState = {
    counter: [],
    Index: [],
    time: { h: 0, m: 0, s: 0, ms: 100 },
    internalaccessories: {
        Four_in_one_sensor: {
            isDistanceSensors: false,
            isGestureSensor: false,
            isLightSensor: false,
            isColorSensor: false,
        },

        // input
        isTouchZero: false,
        isTouchOne: false,
        isTouchTwo: false,
        isTouchThree: false,
        isMic: false,
        isTemperature: false,
        isBattery: false,
        isAccelerometer: false,
        isAccelerometerX: false,
        isAccelerometerY: false,
        isAccelerometerZ: false,
        isGyroX: false,
        isGyroY: false,
        isGyroZ: false,
        isUltrasonic: false,
        isSwitchOne: false,
        isSwitchTwo: false,
        portsData,
    },
    isSelectInternalAccessories: {},
    isSelectAll: false,
    graphType: 'lineGraph',
    slopeInfo: {
        selectedPoints: [],
        message: '',
        slope: '',
    },
    graphRunInfo: {
        // run1: {
        //     selectedSensors: [],
        //     label: 'Run 1',
        //     plotData: [],
        //     interValTime: 0,
        //     totalTime:0
        // },
    },
    selectedRunGraph: '',
    selectedTemperatureScale: 'C',
}
if (sessionStorage.getItem('graphPlotStorage') != null) {
    var graphPlotStorage = sessionStorage.getItem('graphPlotStorage')
    graphPlotStorage = JSON.parse(graphPlotStorage)
} else {
    var graphPlotStorage = (defaultState = JSON.parse(
        JSON.stringify(defaultState)
    ))
}

const graphPlotStorage_Reducer = (state = graphPlotStorage, action) => {
    try {
        switch (action.type) {
            case 'GRAPH_PLOTSTORAGE':
                var counter = action.payload
                let newState
                try {
                    newState = JSON.parse(JSON.stringify(state))
                } catch (e) {
                    console.log('ERROR', e)
                    return state
                }
                console.log('fregrgegegeg', counter)
                Object.keys(counter).map((val, index) => {
                    if (
                        [
                            'isDistanceSensors',
                            'isGestureSensor',
                            'isLightSensor',
                            'isColorSensor',
                            'isRedLight',
                            'isGreenLight',
                            'isBlueLight',
                        ].includes(val)
                        // val == 'isDistanceSensors' ||
                        // val == 'isGestureSensor' ||
                        // val == 'isLightSensor' ||
                        // val == 'isColorSensor'
                    ) {
                        state.internalaccessories.Four_in_one_sensor[val] =
                            counter[val]
                    } else if (val == 'time') {
                        state.time = counter[val]
                    } else {
                        state.internalaccessories[val] = counter[val]
                    }
                })

                var data = { ...state }
                sessionStorage.setItem('graphPlotStorage', JSON.stringify(data))
                return data
            case 'SET_SELECT_INTERNAL_ACCESSORIES': {
                let newState = JSON.parse(JSON.stringify(state))
                newState.isSelectInternalAccessories[action.payload.key] =
                    action.payload.value
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'SET_SELECT_INTERNAL_ACCESSORIES_MULTI': {
                let newState = JSON.parse(JSON.stringify(state))
                newState.isSelectInternalAccessories = {
                    ...newState.isSelectInternalAccessories,
                    ...action.payload,
                }
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'SET_SELECT_PORTS': {
                let newState = JSON.parse(JSON.stringify(state))

                newState.internalaccessories.portsData[
                    action.payload.mainInd
                ].ports[action.payload.minorInd].isChecked =
                    action.payload.value
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }

            case 'SELECT_ALL': {
                let newState = JSON.parse(JSON.stringify(state))
                newState.isSelectInternalAccessories = {
                    ...newState.isSelectInternalAccessories,
                    ...action.payload.isSelectInternalAccessories,
                }
                newState.internalaccessories.portsData =
                    action.payload.portsData
                newState.isSelectAll = action.payload.value

                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'DESELECT': {
                let newState = JSON.parse(JSON.stringify(state))

                newState.isSelectInternalAccessories = {}
                let portsData = newState.internalaccessories.portsData
                portsData.map((portDetails) => {
                    portDetails.ports.map((port) => (port.isChecked = false))
                })
                newState.isSelectAll = false
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'SET_GRAPH_TYPE': {
                let newState = JSON.parse(JSON.stringify(state))

                newState.graphType = action.payload
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }

            case 'EDIT_SLOPE_INFO': {
                let newState = JSON.parse(JSON.stringify(state))
                const { selectedPoints, message, slope } = action.payload

                newState = {
                    ...newState,
                    slopeInfo: {
                        ...newState.slopeInfo,
                        ...(selectedPoints && { selectedPoints }),
                        ...(message && { message }),
                        ...(selectedPoints && { slope }),
                    },
                }
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'SET_SELECTED_GRAPH_RUN': {
                let newState = JSON.parse(JSON.stringify(state))

                newState.selectedRunGraph = action.payload
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'ADD_GRAPH': {
                let newState = JSON.parse(JSON.stringify(state))
                const { selectedSensors, interValTime, totalTime } =
                    action.payload

                let len = Object.keys(newState.graphRunInfo).length
                newState.graphRunInfo[`run${len + 1}`] = {
                    selectedSensors: selectedSensors,
                    label: `Run ${len + 1}`,
                    plotData: [],
                    interValTime,
                    totalTime,
                }
                newState.selectedRunGraph = `run${len + 1}`

                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }
            case 'ADD_PLOT_DATA': {
                let newState = JSON.parse(JSON.stringify(state))
                const { totalTime, plotData } = action.payload

                if (totalTime) {
                    newState.graphRunInfo[newState.selectedRunGraph].totalTime =
                        totalTime
                }
                if (plotData) {
                    newState.graphRunInfo[newState.selectedRunGraph].plotData =
                        plotData
                }
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }

            case 'SET_TEMP_SCALE': {
                let newState = JSON.parse(JSON.stringify(state))
                newState.selectedTemperatureScale = action.payload

                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }

            case 'RESET_STATE': {
                let newState = JSON.parse(JSON.stringify(defaultState))

                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(newState)
                )
                return newState
            }

            default:
                sessionStorage.setItem(
                    'graphPlotStorage',
                    JSON.stringify(state)
                )
                return state
        }
    } catch (e) {
        console.log('ERROR', e)
    }
}

export default graphPlotStorage_Reducer
